import { httpV2 } from "../http.js";

const CRMPipelineService = {
  getPipelines: () => httpV2.get("/crm-pipelines"),
  getBoard: (pipelineId) => httpV2.get(`/crm-pipelines/${pipelineId}/board`),
  createOpportunity: (data) => httpV2.post("/crm-pipelines/opportunities", data),
  updateOpportunity: (id, data) => httpV2.put(`/crm-pipelines/opportunities/${id}`, data),
  moveOpportunity: (id, stageId) =>
    httpV2.put(`/crm-pipelines/opportunities/${id}/stage`, { stage_id: stageId }),
  deleteOpportunity: (id) => httpV2.delete(`/crm-pipelines/opportunities/${id}`),
};

export default CRMPipelineService;
